export default __webpack_public_path__ + "static/media/Spiderman_11.cd9f6ed6.png";